import React, { Component } from "react";
import { css } from "emotion";
import { Button, Container, Select, Text, TextInput } from "../../components";
// import initialQuestions from "../../assets/questions.json";
import initialQuestions from "../../assets/questions-2.json";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "react-text-mask";
import XCircle from "react-feather/dist/icons/x-circle";
import {
  firebase,
  BORDER,
  BACKGROUND,
  SECONDARY_TEXT,
  UNSTUCK_BLUE,
} from "../../constants";

const repeatQuestions = [];

const currencyMask = createNumberMask({ allowDecimal: true });
const numberMask = createNumberMask({ prefix: "", allowDecimal: true });
const yearMask = [/\d/, /\d/, /\d/, /\d/];
const inputClass = css`
  font-size: 1em;
  padding: 1em;
  border-radius: 4px;
  border: 1px solid ${BACKGROUND};
`;

const Input = ({ id, type, label, placeholder, options, value, onChange }) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };
  const handleMaskChange = (e) =>
    onChange(e.target.value.replace(/[^0-9\.-]+/g, ""));

  switch (type) {
    case "select":
      return (
        <Select name={id} value={value} onChange={handleChange} autoFocus>
          <option disabled selected>
            Select...
          </option>
          {options.map((o) => (
            <option value={o}>{o}</option>
          ))}
        </Select>
      );
    case "date":
      return (
        <MaskedInput
          mask={yearMask}
          value={value}
          placeholder={placeholder}
          onChange={handleMaskChange}
          className={inputClass}
          autoFocus
        />
      );
    case "currency":
      return (
        <MaskedInput
          mask={currencyMask}
          value={value}
          placeholder={placeholder}
          onChange={handleMaskChange}
          className={inputClass}
          autoFocus
        />
      );
    case "number":
      return (
        <MaskedInput
          mask={numberMask}
          value={value}
          placeholder={placeholder}
          onChange={handleMaskChange}
          className={inputClass}
          autoFocus
        />
      );
    case "radio":
      return (
        <fieldset
          className={css`
            margin: 0;
            padding: 0;
            border: none;
          `}
        >
          <div
            className={css`
              display: flex;
              flex-wrap: wrap;
              margin: -5px;
            `}
          >
            {options.map((o) => (
              <label
                className={css`
                  position: relative;
                  display: block;
                  margin: 5px;
                `}
              >
                <input
                  name={id}
                  type="radio"
                  value={o}
                  checked={value == o}
                  onChange={handleChange}
                  className={css`
                    position: absolute;
                    visibility: hidden;
                    &:checked + div {
                      border-color: ${UNSTUCK_BLUE};
                      box-shadow: 0 10px 20px 0 ${BACKGROUND};
                    }
                    &:active + div {
                      box-shadow: 0 10px 20px 0 ${BACKGROUND};
                    }
                  `}
                />
                <div
                  className={css`
                    padding: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 2px solid ${BACKGROUND};
                    background-color: white;
                    border-radius: 4px;
                    font-weight: bold;
                  `}
                >
                  {o}
                </div>
              </label>
            ))}
          </div>
        </fieldset>
      );
    case "array":
      const values = Array.isArray(value) ? value : [];
      const handleArrayChange = (e) => {
        let nextValues = [...values];
        nextValues.splice(e.target.name, 1, e.target.value);
        onChange(nextValues);
      };
      const handleArrayRemove = (index) => {
        let nextValues = [...values];
        nextValues.splice(index, 1);
        onChange(nextValues);
      };
      return (
        <div
          className={css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          `}
        >
          {values.map((value, index) => (
            <div
              key={index}
              className={css`
                position: relative;
              `}
            >
              <TextInput
                name={index}
                type="text"
                value={value}
                placeholder={placeholder}
                onChange={handleArrayChange}
                autoFocus
                className={css`
                  padding-right: 3em;
                `}
              />
              <Button
                tabIndex="-1"
                onClick={(e) => handleArrayRemove(index)}
                className={css`
                  position: absolute;
                  right: 0;
                  top: 50%;
                  transform: translateY(-50%);
                `}
              >
                <XCircle size="1em" color={SECONDARY_TEXT} />
              </Button>
            </div>
          ))}
          <div key={values.length}>
            <TextInput
              name={values.length}
              type="text"
              placeholder={placeholder}
              onChange={handleArrayChange}
              autoFocus={values.length === 0}
              className={css`
                padding-right: 3em;
              `}
            />
          </div>
        </div>
      );
    case "text":
    default:
      return (
        <input
          name={id}
          type="number"
          value={value}
          onChange={handleChange}
          className={inputClass}
          autoFocus
        />
      );
  }
};

class DashboardAssessment extends Component {
  state = {
    index: this.initialIndex,
    responses: this.props.responses || {},
  };

  componentDidMount() {
    window.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount() {
    window.removeEventListener("keyup", this.handleKeyUp);
  }

  handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      this.submitQuestion();
    }
  };

  get initialIndex() {
    if (this.props.responses) {
      const answers = Object.values(this.props.responses).filter((r) => r);
      return answers.length;
    }
    return 0;
  }

  prev = () => {
    this.setState({ index: this.state.index - 1 });
  };

  submitAssessment = async () => {
    try {
      await firebase
        .database()
        .ref()
        .child("church")
        .child(this.props.user.uid)
        .child("assessments")
        .child(this.props.assessmentKey)
        .child("timeSubmitted")
        .set(firebase.database.ServerValue.TIMESTAMP);
    } catch (error) {
      this.setState({ error });
    }
  };

  submitQuestion = async () => {
    try {
      await firebase
        .database()
        .ref()
        .child("church")
        .child(this.props.user.uid)
        .child("assessments")
        .child(this.props.assessmentKey)
        .child("responses")
        .child(this.currentQuestion.id)
        .set(this.currentAnswer);
      this.setState({ index: this.state.index + 1 });
    } catch (error) {
      this.setState({ error });
    }
  };

  handleAnswer = (value) => {
    this.setState({
      responses: {
        ...this.state.responses,
        [this.currentQuestion.id]: value,
      },
    });
  };

  get questions() {
    let questions = [];
    if (
      this.state.responses.campuses &&
      this.state.responses.campuses.length > 0
    ) {
      questions = [...initialQuestions];
      this.state.responses.campuses.forEach((campusName, index) => {
        questions = [
          ...questions,
          ...repeatQuestions.map((question) => ({
            ...question,
            id: `${question.id}@${index}`,
          })),
        ];
      });
    } else {
      questions = [...initialQuestions, ...repeatQuestions];
    }
    // Filter out invalid conditional questions
    questions = questions.filter((q) => {
      if (q.if) {
        const [_, campusId] = q.id.split("@");
        let compareId = q.if.id;
        if (campusId) {
          compareId += "@" + campusId;
        }
        if (q.if.isnt) {
          return this.state.responses[compareId] !== q.if.isnt;
        }
        if (q.if.is) {
          return this.state.responses[compareId] === q.if.is;
        }
        if (q.if.has) {
          return (
            this.state.responses[compareId] &&
            !!this.state.responses[compareId][q.if.has]
          );
        }
      }
      return true;
    });

    return questions;
  }

  get progress() {
    if (this.state.responses) {
      const answers = Object.values(this.state.responses).filter((r) => r);

      return answers.length / this.questions.length;
    }
    return 0;
  }

  get currentQuestion() {
    return this.questions[this.state.index];
  }

  get currentCampusLabel() {
    const { id } = this.currentQuestion;
    // "0.campus_seats" -> field for first campus
    if (id.indexOf("@") > -1) {
      const index = id.split("@").pop();
      const campusName = this.state.responses.campuses[index];
      return campusName;
    }
  }

  get currentAnswer() {
    if (this.currentQuestion) {
      let answer = this.state.responses[this.currentQuestion.id];
      if (this.currentQuestion.id === "campuses") {
        return answer || {};
      }
      return answer;
    }
  }

  render() {
    // User has reached the end
    if (this.state.index > this.questions.length - 1) {
      return (
        <Container style={{ margin: 0 }}>
          <div
            className={css`
              position: relative;
              margin-top: 30vh;
            `}
          >
            <Text.H1>You're done!</Text.H1>
            <br />
            <Text.Large>Submit your answers to get your results!</Text.Large>
            <br />
            <br />
            <Button kind="primary" onClick={this.submitAssessment}>
              Submit your answers
            </Button>
          </div>
        </Container>
      );
    }

    return (
      <Container style={{ margin: 0 }}>
        <div
          key={this.currentQuestion.id}
          className={css`
            position: relative;
            display: flex;
            flex-direction: column;
            min-height: calc(100vh - 80px);
            @media (max-width: 1000px) {
              min-height: calc(100vh - 240px);
            }
          `}
        >
          <div
            className={css`
              flex-grow: 1;
              display: flex;
              align-items: flex-start;
              flex-direction: column;
              justify-content: center;
            `}
          >
            <Text.H3
              measure
              className={css`
                &:first-letter {
                  text-transform: capitalize;
                }
              `}
            >
              {this.currentCampusLabel && `For ${this.currentCampusLabel}: `}
              {this.currentQuestion.label}
            </Text.H3>
            <br />
            <Input
              {...this.currentQuestion}
              value={this.currentAnswer}
              onChange={this.handleAnswer}
            />
          </div>
          <footer
            className={css`
              flex-shrink: 0;
              display: flex;
              padding: 20px 0 40px;
              button {
                margin: 0;
              }
              button + button {
                margin-left: 10px;
              }
            `}
          >
            <Button
              kind="outline"
              onClick={this.prev}
              disabled={this.state.index === 0}
            >
              Prev
            </Button>
            <Button kind="primary" onClick={this.submitQuestion}>
              Next
            </Button>
          </footer>
          <div
            className={css`
              position: absolute;
              left: 0;
              right: 0;
              bottom: -25px;
              width: 100%;
              height: 3px;
              background-color: ${BORDER};
              &::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                width: ${this.progress * 100}%;
                background-color: ${UNSTUCK_BLUE};
              }
            `}
          />
        </div>
      </Container>
    );
  }
}

export default DashboardAssessment;



// WEBPACK FOOTER //
// ./src/screens/dash/DashboardAssessment.js